<div class="step-one">
  <h3>Crear Regla</h3>
  <div class="step-one__selectors">
    <div class="step-one__position">
      <p class="step-one__label">De:</p>
      <div
        class="step-one__box step-one__selectors-select"
        (click)="
          srcCoinSelectorOpened = !srcCoinSelectorOpened;
          destCoinSelectorOpened = false;
          openSelectSrcCoin.emit(srcCoinSelectorOpened);
          $event.stopPropagation()
        "
      >
        <div class="step-one__selectors-coin">
          <img
            *ngIf="fromTicker"
            class="coin-icon"
            [src]="'/assets/icons/crypto/' + fromTicker.toLowerCase() + '.svg'"
            alt="coin"
          />
          <p class="coin-ticker">{{ fromTicker | arsUsdLabel }}</p>
        </div>
        <img src="/assets/icons/expand.svg" alt="expand" />
      </div>
      <div class="step-one__coin-selector-content" *ngIf="srcCoinSelectorOpened">
        <div *ngFor="let coin of availableCoins" class="coin-option" (click)="selectCoin(coin)">
          <img [src]="'/assets/icons/crypto/' + coin.toLowerCase() + '.svg'" alt="coin" />
          <div class="option-row">
            <p>{{ coin | arsUsdLabel }}</p>
          </div>
        </div>
      </div>
    </div>
    <img
      class="step-one__selectors-swap"
      src="/assets/icons/swap-rules.svg"
      alt="swap-coins"
      (click)="switchCoins()"
    />
    <div class="step-one__position">
      <p class="step-one__label">hacia:</p>
      <div
        class="step-one__box step-one__selectors-select"
        (click)="
          destCoinSelectorOpened = !destCoinSelectorOpened;
          srcCoinSelectorOpened = false;
          openSelectDestCoin.emit(destCoinSelectorOpened);
          $event.stopPropagation()
        "
      >
        <div class="step-one__selectors-coin">
          <img
            *ngIf="toTicker"
            class="coin-icon"
            [src]="'/assets/icons/crypto/' + toTicker.toLowerCase() + '.svg'"
            alt="coin"
          />
          <p class="coin-ticker">{{ toTicker | arsUsdLabel }}</p>
        </div>
        <img src="/assets/icons/expand.svg" alt="expand" />
      </div>
      <div class="step-one__coin-selector-content right" *ngIf="destCoinSelectorOpened">
        <div
          *ngFor="let coin of availableCoins"
          class="coin-option"
          [class.disappear]="
            fromTicker === coin ||
            (fromTicker === 'ARS' && coin === 'USD') ||
            (fromTicker === 'USD' && coin === 'ARS')
          "
          [class.disabled]="
            fromTicker !== 'ARS' && fromTicker !== 'USD'
              ? cryptoService.getValidSwapPair(fromTicker, coin) === '' &&
                coin !== 'ARS' &&
                coin !== 'USD'
              : ''
          "
          (click)="selectCoin(coin)"
        >
          <img [src]="'/assets/icons/crypto/' + coin.toLowerCase() + '.svg'" alt="coin" />
          <div class="option-row">
            <p>{{ coin | arsUsdLabel }}</p>
            <span
              *ngIf="
                fromTicker !== 'ARS' && fromTicker !== 'USD'
                  ? cryptoService.getValidSwapPair(fromTicker, coin) === '' &&
                    coin !== 'ARS' &&
                    coin !== 'USD'
                  : ''
              "
              class="comming-soon-text"
              >Próximamente</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="step-one__input">
    <p class="step-one__label">
      Monto
      <span
        >Disponible:
        {{
          (balance ? (balance | number : '0.1-8') : '0,00') + ' ' + (fromTicker | arsUsdLabel)
        }}</span
      >
    </p>
    <div class="step-one__box">
      <input
        [formControl]="amount"
        type="text"
        [mask]="checkIsStable ? 'separator.3' : 'separator.8'"
        thousandSeparator="."
      />
      <p class="step-one__input-coin">{{ fromTicker | arsUsdLabel }}</p>
    </div>
  </div>
  <div class="step-one__period">
    <p class="step-one__label">Ciclo</p>
    <div class="step-one__period-buttons">
      <button
        *ngFor="let frequency of frequencyButtons"
        [class.active]="frequency === selectFrequency"
        (click)="changeFrecuency(frequency)"
      >
        {{ frequency | frequencyTransform }}
      </button>
    </div>
    <!-- La solicitud de fondos queda para una próxima etapa -->
    <!-- <mat-checkbox
      >Enviar solicitud de fondos a tu banco <img src="/assets/icons/dca/info-create.svg" alt="create"
    /></mat-checkbox> -->
  </div>
  <div class="step-one__time">
    <p class="step-one__label">Repetición</p>
    <div class="step-one__box">
      <div class="step-one__time-contain">
        <input
          (input)="checkValidHour()"
          (keydown)="restrictDecimal($event)"
          type="number"
          [formControl]="timeReplay"
          max="12"
          min="1"
        />
        <p>:00 hs</p>
        <div class="step-one__time-arrows">
          <img (click)="changeHour(+1)" src="/assets/icons/dca/arrow-up.svg" alt="Arrow up" />
          <img (click)="changeHour(-1)" src="/assets/icons/dca/arrow-down.svg" alt="Arrow down" />
        </div>
      </div>
      <div class="step-one__time-pills">
        <div
          (click)="changePeriod('AM')"
          class="step-one__time-pills-default"
          [class.active]="period === 'AM'"
        >
          <p>AM</p>
        </div>
        <div
          (click)="changePeriod('PM')"
          class="step-one__time-pills-default"
          [class.active]="period === 'PM'"
        >
          <p>PM</p>
        </div>
      </div>
    </div>
  </div>
  <div class="step-one__next-btn">
    <button
      (click)="changeStep()"
      class="td-btn primary"
      [disabled]="timeReplay.invalid || amount.invalid"
    >
      Siguiente
    </button>
  </div>
</div>
